<div class="LabelPreview">
    <div class="LabelPreview__templates">
        <button type="button" mat-stroked-button *ngFor="let template of templates"
            [color]="template.key === selectedTemplate.key ? 'primary' : undefined"
            (click)="onSelectTemplate(template)">{{ template.label | translate }}</button>
    </div>

    <div class="LabelPreview__stage">
        <img *ngIf="isPrinterPreview" [src]="printerPreviewSrc" alt="{{ 'labelLogo.preview' | translate }}"/>
        <canvas #mock [hidden]="isPrinterPreview"></canvas>
    </div>

    <div class="LabelPreview__note" *ngIf="!isPrinterPreview">{{ 'labelLogo.mockNote' | translate }}</div>

    <div class="LabelPreview__facts" *ngIf="fit && hasLogo">
        <span>{{ 'labelLogo.printedSize' | translate }}: {{ fit.widthMm }} × {{ fit.heightMm }} mm</span>
    </div>

    <div class="LabelPreview__warning" *ngIf="!hasLogo && !isLoading">
        <mat-icon>info</mat-icon>
        <span>{{ 'labelLogo.warningBlank' | translate }}</span>
    </div>

    <div class="LabelPreview__warning" *ngFor="let warning of fit?.warnings">
        <mat-icon>warning</mat-icon>
        <span>{{ warning | translate }}</span>
    </div>
</div>
